// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--ozgaI","text":"_93444fe79c--text--QKAko"};